import { useAtom } from 'jotai';

import { currentPageAtom, prevPageAtom } from '../store/index.atom';

const useUpdateViewerPageState = () => {
  const [currentPage, setCurrentPage] = useAtom(currentPageAtom);
  const [prevPage, setPrevPage] = useAtom(prevPageAtom);

  const initPageState = () => {
    setCurrentPage(1);
    setPrevPage(1);
  };

  const updateCurrentPage = (page: number) => {
    /*이전 페이지를 prev page에 업데이트 해준 이후에 새로운 페이지로 이동시킨다 */
    setCurrentPage((prev) => {
      setPrevPage(prev);
      return page;
    });
  };

  return {
    initPageState,
    updateCurrentPage,
    currentPage,
    prevPage,
  };
};

export default useUpdateViewerPageState;
